import Grid2 from '@mui/material/Unstable_Grid2';

import BlogCuratedArticleList from '@/components/BlogComponents/BlogCuratedArticleList/BlogCuratedArticleList';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import type { CuratedArticleSplitType } from '@/contentful/api/types';

import useStyles from './BlogCuratedArticleSplit.styles';
import BlogCuratedArticleSquareCard from './BlogCuratedArticleSquareCard/BlogCuratedArticleSquareCard';

export default function BlogCuratedArticleSplit({
  content,
}: {
  content: CuratedArticleSplitType;
}): React.JSX.Element {
  const { classes } = useStyles();
  const { articlesCollection, articleListHeading } = content;

  const featuredArticle = articlesCollection.items[0];
  const listOfArticles = articlesCollection.items.slice(1);

  return (
    <SpacingContainer
      isFeatured
      className={classes.spacingContainer}
      data-testid='blogCuratedArticleSplit'
    >
      <GridContainer2 fixed>
        <Grid2 className={classes.gridItem}>
          <BlogCuratedArticleSquareCard featuredArticle={featuredArticle} />
          <BlogCuratedArticleList
            heading={articleListHeading}
            articles={listOfArticles}
          />
        </Grid2>
      </GridContainer2>
    </SpacingContainer>
  );
}
